import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomSeatComfort, SeatInfo } from '@entities/seat-map';
import { useTheme } from '../../../../../theme';
const SeatsList = ({ seats }) => {
    const { SeatsList: css } = useTheme('Entities').SeatMap;
    const { t } = useTranslation('SeatMap');
    return (!!seats.length && (React.createElement("div", { className: css.seatsList__items },
        seats.map(item => (React.createElement(SeatInfo, Object.assign({ className: css.seatsList__item }, item)))),
        React.createElement(SeatInfo, { className: css.seatsList__item, name: t('Reserved seat'), seats: [{ comfort: CustomSeatComfort.Unavaliable }] }))));
};
export default SeatsList;
